import React from 'react';
import { motion } from 'framer-motion';
import { X, AlertCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Hoy otra vez le di pantalla…', 'Yo quería jugar más, pero no me dio.', 'Busqué actividades y me abrumé.', 'Todo parece requerir imprimir, comprar o preparar un montón.'];
  return <section className="py-12 px-6 bg-[#F5E6D0]/30" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-56">
          <h2 className="text-3xl md:text-5xl font-bold text-[#2D3A4A] mb-6" data-id="element-57">
            Esto no es para la mamá perfecta.
          </h2>
          <p className="text-xl text-[#2D3A4A]/80 max-w-2xl mx-auto" data-id="element-58">
            Es para la mamá (o el papá) que llega al final del día pensando:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-[#F5E6D0]" data-id="element-60">
            <ul className="space-y-4" data-id="element-61">
              {painPoints.map((point, index) => <li key={index} className="flex items-start text-lg text-[#2D3A4A]" data-id="element-62">
                  <div className="bg-red-100 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-63">
                    <X className="w-4 h-4 text-red-500" data-id="element-64" />
                  </div>
                  "{point}"
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-65">
              <p className="font-serif text-xl text-[#C4704B] italic" data-id="element-66">
                Y lo peor no es la pantalla. Lo peor es la repetición: mañana
                vuelve a pasar.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#2D3A4A] text-[#FFFBF5] p-8 rounded-3xl shadow-lg relative overflow-hidden" data-id="element-67">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#C4704B] rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-68" />

            <h3 className="text-2xl font-bold mb-4 flex items-center" data-id="element-69">
              <AlertCircle className="w-6 h-6 text-[#C4704B] mr-2" data-id="element-70" />
              La trampa que nadie dice
            </h3>
            <p className="mb-4 text-[#FFFBF5]/90 leading-relaxed" data-id="element-71">
              Cuando estás cansada, tu cerebro no quiere "más opciones".{' '}
              <strong className="text-[#F5E6D0]" data-id="element-72">
                Quiere cero decisiones.
              </strong>
            </p>
            <p className="mb-4 text-[#FFFBF5]/90 leading-relaxed" data-id="element-73">
              Por eso Pinterest no ayuda. Por eso TikTok no ayuda. Porque te
              dejan con el trabajo más pesado: elegir una y ejecutarla.
            </p>
            <p className="text-[#FFFBF5]/90 leading-relaxed" data-id="element-74">
              Y cuando elegís, aparece el problema logístico: "¿Dónde están los
              materiales? ¿Tengo que recortar?". <br data-id="element-75" />
              <span className="block mt-4 font-bold text-[#F5E6D0]" data-id="element-76">
                Resultado: lo postergás. Y la pantalla vuelve a ganar.
              </span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}